import { render, staticRenderFns } from "./feedActionBar.vue?vue&type=template&id=ff5bf86a&scoped=true&"
import script from "./feedActionBar.vue?vue&type=script&lang=js&"
export * from "./feedActionBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5bf86a",
  null
  
)

export default component.exports